import { IRuleBase, INestedRuleBase, IHavingRule } from './rule-interface';

export function isNestedRule(rule: IRuleBase): rule is INestedRuleBase {
  return !!(rule as INestedRuleBase).rules;
}

export function countHavingRulesOfType(rule: IRuleBase | undefined, type: string): number {
  if (!rule || !isNestedRule(rule)) return 0;
  const isHavingOfType = !!(rule as IHavingRule).cardinality && (rule as IHavingRule).type === type ? 1 : 0;
  return isHavingOfType + rule.rules.reduce<number>((count, childRule) => count + countHavingRulesOfType(childRule, type), 0);
}

/** The type of the nearest enclosing having group, which is the type whose fields the rules on that path use. */
export function findHavingTypeByPath(root: INestedRuleBase, path: string): string | undefined {
  const segments = path.split('.').slice(1);
  let current: IRuleBase | undefined = root;
  let havingType: string | undefined;
  for (let i = 0; i < segments.length; i += 1) {
    if (!current || !isNestedRule(current)) return havingType;
    current = current.rules[Number(segments[i])];
    if (current && (current as IHavingRule).cardinality) havingType = (current as IHavingRule).type;
  }
  return havingType;
}

export function findNestedRuleByPath(root: INestedRuleBase, path: string): INestedRuleBase | undefined {
  const segments = path.split('.').slice(1);
  let current: IRuleBase | undefined = root;
  for (let i = 0; i < segments.length; i += 1) {
    if (!current || !isNestedRule(current)) return undefined;
    current = current.rules[Number(segments[i])];
  }
  return current && isNestedRule(current) ? current : undefined;
}
